import { render, staticRenderFns } from "./ClientInfo.vue?vue&type=template&id=d773e830&scoped=true&"
import script from "./ClientInfo.vue?vue&type=script&lang=js&"
export * from "./ClientInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d773e830",
  null
  
)

export default component.exports